import { render, staticRenderFns } from "./AutomaticControl.vue?vue&type=template&id=6da40c73&scoped=true"
import script from "./AutomaticControl.vue?vue&type=script&lang=js"
export * from "./AutomaticControl.vue?vue&type=script&lang=js"
import style0 from "./AutomaticControl.vue?vue&type=style&index=0&id=6da40c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6da40c73",
  null
  
)

export default component.exports